module.exports = __webpack_public_path__ + "static/media/home-logo-soh.5af85ad2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-logo-soh.png
// module id = 730
// module chunks = 1